import { Card, CardContent, CardHeader, CardTitle } from '../ui/card';
import { List, ListItem } from '../ui/list';

interface SupportInfoProps {
  title?: string;
  description?: string;
  items: string[];
  bgColor?: string;
  borderColor?: string;
  titleColor?: string;
  itemColor?: string;
}

const SupportInfo = ({
  title = 'What happens next?',
  description,
  items,
  bgColor = 'bg-blue-50',
  borderColor = 'border-blue-200',
  titleColor = 'text-blue-900',
  itemColor = 'text-blue-700',
}: SupportInfoProps) => {
  return (
    <Card>
      <CardHeader>
        <CardTitle className="text-lg">Support Information</CardTitle>
      </CardHeader>
      <CardContent>
        <div className={`${bgColor} ${borderColor} border rounded-lg p-4`}>
          {title && (
            <h4 className={`text-sm font-medium ${titleColor} mb-2`}>
              {title}
            </h4>
          )}
          {description && (
            <p className={`text-sm ${itemColor} mb-3`}>{description}</p>
          )}
          <List className={`text-sm ${itemColor}`}>
            {items.map((item, index) => (
              <ListItem key={index}>• {item}</ListItem>
            ))}
          </List>
        </div>
      </CardContent>
    </Card>
  );
};

export default SupportInfo;
